import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const login = async (username: string, password: string): Promise<{ token: string, status: number, message: string }> => {
    const endpoint = process.env.REACT_APP_API_ENDPOINT;

    try {
        const response = await fetch(`${endpoint}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username, password }),
        });

        if (!response.ok) {
            const errorMessage = await response.text();
            return { token: '', status: response.status, message: errorMessage };
        }

        const data = await response.json();
        return { token: data.token, status: 200, message: '' };
    } catch (error) {
        return { token: '', status: 0, message: 'Network error. Please try again later.' };
    }
};

const Login: React.FC<{ onLogin: (token: string) => void }> = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<{ status: number, message: string } | null>(null);
    const navigate = useNavigate();

    const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUsername(event.target.value);
    };

    const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const result = await login(username, password);
        if (result.status === 200) {
            onLogin(result.token);
        } else {
            setError({ status: result.status, message: result.message });
        }
    };

    const handleClose = () => {
        setError(null);
    };

    return (
        <Box className="login" sx={{ textAlign: 'center' }}>
            <Typography variant="h5" component="h1" color="primary">
                Login
            </Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    type="text"
                    value={username}
                    onChange={handleUsernameChange}
                    placeholder="Enter username"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                />
                <TextField
                    type="password"
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="Enter password"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                />
                <Button type="submit" variant="contained" color="primary">
                    Login
                </Button>
            </form>
            <Dialog open={!!error} onClose={handleClose}>
                <DialogTitle>Error</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {error?.message || 'An unknown error occurred. Please try again.'}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Login;